import type { SVGProps } from 'react'

const SvgOcrRejected = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="143"
    height="85"
    viewBox="0 0 143 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_14700_16125)">
      <path d="M142.222 79.1445H0V79.2049H142.222V79.1445Z" fill="#F7F7F7" />
      <path
        d="M127.972 83.0352H118.551V83.0955H127.972V83.0352Z"
        fill="#F7F7F7"
      />
      <path
        d="M94.214 83.6914H91.7422V83.7518H94.214V83.6914Z"
        fill="#F7F7F7"
      />
      <path
        d="M118.267 80.793H112.809V80.8534H118.267V80.793Z"
        fill="#F7F7F7"
      />
      <path
        d="M27.207 81.1992H14.9219V81.2596H27.207V81.1992Z"
        fill="#F7F7F7"
      />
      <path
        d="M31.5427 81.1992H29.7422V81.2596H31.5427V81.1992Z"
        fill="#F7F7F7"
      />
      <path
        d="M64.0432 82.2148H37.3965V82.2752H64.0432V82.2148Z"
        fill="#F7F7F7"
      />
      <path
        d="M67.4156 68.3751H12.4894C11.5934 68.3751 10.8652 67.7568 10.8652 66.996V1.43773C10.8652 0.676909 11.5934 0.0585938 12.4894 0.0585938H67.4156C68.3116 0.0585938 69.0398 0.676909 69.0398 1.43773V66.996C69.0398 67.7568 68.3116 68.3751 67.4156 68.3751ZM12.4894 0.118976C11.6332 0.118976 10.9363 0.710723 10.9363 1.43773V66.996C10.9363 67.723 11.6332 68.3148 12.4894 68.3148H67.4156C68.2718 68.3148 68.9687 67.723 68.9687 66.996V1.43773C68.9687 0.710723 68.2718 0.118976 67.4156 0.118976H12.4894Z"
        fill="#F7F7F7"
      />
      <path
        d="M128.941 68.3751H74.0148C73.1188 68.3751 72.3906 67.7568 72.3906 66.996V1.43773C72.3906 0.676909 73.1188 0.0585938 74.0148 0.0585938H128.941C129.837 0.0585938 130.565 0.676909 130.565 1.43773V66.996C130.565 67.7568 129.837 68.3751 128.941 68.3751ZM74.0148 0.118976C73.1586 0.118976 72.4617 0.710723 72.4617 1.43773V66.996C72.4617 67.723 73.1586 68.3148 74.0148 68.3148H128.941C129.797 68.3148 130.494 67.723 130.494 66.996V1.43773C130.494 0.710723 129.797 0.118976 128.941 0.118976H74.0148Z"
        fill="#F7F7F7"
      />
      <path
        d="M71.1118 83.9356C101.571 83.9356 126.263 82.4792 126.263 80.6827C126.263 78.8861 101.571 77.4297 71.1118 77.4297C40.6528 77.4297 15.9609 78.8861 15.9609 80.6827C15.9609 82.4792 40.6528 83.9356 71.1118 83.9356Z"
        fill="#E6F2FE"
      />
      <path
        d="M118.444 7.96484H23.7751C21.4486 7.96484 19.5625 9.87027 19.5625 12.2207V73.3693C19.5625 75.7197 21.4486 77.6252 23.7751 77.6252H118.444C120.77 77.6252 122.657 75.7197 122.657 73.3693V12.2207C122.657 9.87027 120.77 7.96484 118.444 7.96484Z"
        fill="white"
      />
      <path
        d="M118.445 77.7793H23.7764C21.37 77.7793 19.4102 75.7993 19.4102 73.3682V12.2197C19.4102 9.78854 21.37 7.80859 23.7764 7.80859H118.448C120.854 7.80859 122.814 9.78854 122.814 12.2197V73.3682C122.814 75.7993 120.854 77.7793 118.448 77.7793H118.445ZM23.7764 8.11895C21.5378 8.11895 19.7174 9.95809 19.7174 12.2197V73.3682C19.7174 75.6298 21.5378 77.4689 23.7764 77.4689H118.448C120.687 77.4689 122.507 75.6298 122.507 73.3682V12.2197C122.507 9.95809 120.687 8.11895 118.448 8.11895H23.7764Z"
        fill="#66B0F6"
      />
      <path
        d="M27.7097 12.445C27.7097 13.2036 27.101 13.8157 26.3529 13.8157C25.6048 13.8157 24.9961 13.2007 24.9961 12.445C24.9961 11.6892 25.6048 11.0742 26.3529 11.0742C27.101 11.0742 27.7097 11.6892 27.7097 12.445Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M36.6252 13.2519H29.9635C29.5255 13.2519 29.1699 12.8899 29.1699 12.4502C29.1699 12.0076 29.5283 11.6484 29.9635 11.6484H36.6252C37.0632 11.6484 37.4188 12.0105 37.4188 12.4502C37.4188 12.8927 37.0604 13.2519 36.6252 13.2519Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M68.7395 12.8872H64.0661C63.8243 12.8872 63.6309 12.6889 63.6309 12.4475C63.6309 12.2032 63.8271 12.0078 64.0661 12.0078H68.7395C68.9813 12.0078 69.1747 12.2061 69.1747 12.4475C69.1747 12.6917 68.9784 12.8872 68.7395 12.8872Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M79.2258 12.8872H74.5524C74.3106 12.8872 74.1172 12.6889 74.1172 12.4475C74.1172 12.2032 74.3135 12.0078 74.5524 12.0078H79.2258C79.4676 12.0078 79.661 12.2061 79.661 12.4475C79.661 12.6917 79.4647 12.8872 79.2258 12.8872Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M89.7141 12.8872H85.0407C84.7989 12.8872 84.6055 12.6889 84.6055 12.4475C84.6055 12.2032 84.8017 12.0078 85.0407 12.0078H89.7141C89.9559 12.0078 90.1493 12.2061 90.1493 12.4475C90.1493 12.6917 89.953 12.8872 89.7141 12.8872Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.2"
        d="M100.204 12.8872H95.5309C95.2891 12.8872 95.0957 12.6889 95.0957 12.4475C95.0957 12.2032 95.292 12.0078 95.5309 12.0078H100.204C100.446 12.0078 100.64 12.2061 100.64 12.4475C100.64 12.6917 100.443 12.8872 100.204 12.8872Z"
        fill="#C8C8C8"
      />
      <path
        opacity="0.7"
        d="M113.624 13.2236H106.553C106.129 13.2236 105.785 12.8759 105.785 12.4478C105.785 12.0196 106.129 11.6719 106.553 11.6719H113.624C114.048 11.6719 114.392 12.0196 114.392 12.4478C114.392 12.8759 114.048 13.2236 113.624 13.2236Z"
        fill="#C8C8C8"
      />
      <path
        d="M110.279 21.9825L32.7339 21.9405C29.6448 21.9389 27.1187 22.1008 27.0917 22.3023L26.2293 28.7368C26.2023 28.9383 28.6846 29.103 31.7736 29.1046L109.319 29.1466C112.408 29.1483 114.934 28.9863 114.961 28.7848L115.824 22.3504C115.851 22.1489 113.369 21.9842 110.279 21.9825Z"
        fill="#F7F7F7"
      />
      <path
        d="M110.279 30.2637L32.7339 30.2218C29.6448 30.2201 27.1187 30.3821 27.0917 30.5836L26.2293 37.018C26.2023 37.2195 28.6846 37.3842 31.7736 37.3859L109.319 37.4278C112.408 37.4295 114.934 37.2675 114.961 37.066L115.824 30.6316C115.851 30.4301 113.369 30.2654 110.279 30.2637Z"
        fill="#F7F7F7"
      />
      <path
        d="M110.279 38.5411L32.7339 38.4991C29.6448 38.4974 27.1187 38.6594 27.0917 38.8609L26.2293 45.2953C26.2023 45.4968 28.6846 45.6616 31.7736 45.6632L109.319 45.7052C112.408 45.7069 114.934 45.5449 114.961 45.3434L115.824 38.909C115.851 38.7075 113.369 38.5428 110.279 38.5411Z"
        fill="#F7F7F7"
      />
      <path
        d="M110.279 46.8223L32.7339 46.7804C29.6448 46.7787 27.1187 46.9407 27.0917 47.1422L26.2293 53.5766C26.2023 53.7781 28.6846 53.9428 31.7736 53.9445L109.319 53.9864C112.408 53.9881 114.934 53.8261 114.961 53.6246L115.824 47.1902C115.851 46.9887 113.369 46.824 110.279 46.8223Z"
        fill="#F7F7F7"
      />
      <path
        d="M110.279 55.1036L32.7339 55.0616C29.6448 55.0599 27.1187 55.2219 27.0917 55.4234L26.2293 61.8578C26.2023 62.0593 28.6846 62.2241 31.7736 62.2257L109.319 62.2677C112.408 62.2694 114.934 62.1074 114.961 61.9059L115.824 55.4715C115.851 55.27 113.369 55.1053 110.279 55.1036Z"
        fill="#F7F7F7"
      />
    </g>
    <defs>
      <clipPath id="clip0_14700_16125">
        <rect width="142.222" height="84.2012" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgOcrRejected
